import { render, staticRenderFns } from "./AccessSetting.vue?vue&type=template&id=a771a0b2&scoped=true&"
import script from "./AccessSetting.vue?vue&type=script&lang=js&"
export * from "./AccessSetting.vue?vue&type=script&lang=js&"
import style0 from "./AccessSetting.vue?vue&type=style&index=0&id=a771a0b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a771a0b2",
  null
  
)

export default component.exports